import { cn } from "@/lib/utils";

import { SpinnerSvg } from "./spinner-svg";

// FUTURE WORK - harmonise with customer app

export interface SpinnerProps {
  inverse?: boolean;
  className?: string;
}

export const Spinner = ({ inverse = false }: SpinnerProps) => (
  <div className="size-8 leading-none" data-testid="spinner-container">
    <SpinnerSvg
      className={cn("animate-spin", {
        "stroke-pulse-100": !inverse,
        "stroke-white": inverse,
      })}
      strokeWidth={4}
      width="100%"
      height="100%"
    />
  </div>
);
